export type SystemEndpointsType = {
  getBackendZipName: string;
  backendImport: string;
};

export const systemEndpoints: SystemEndpointsType = {
  getBackendZipName: "system/backend/export",
  backendImport: "system/backend/import",
};
